import BingoVoting from './bingo';
import BestPlayerVoting from './bestPlayer';
import MatchResultVoting from './matchResult';
import { TYPE_BINGO, TYPE_BEST_PLAYER, TYPE_MATCH_RESULT } from './base';

/**
 *
 * @param type
 * @returns Voting
 */
export default function factory(type): Function {
  switch (type) {
    case TYPE_BINGO:
      return BingoVoting;
    case TYPE_BEST_PLAYER:
      return BestPlayerVoting;
    case TYPE_MATCH_RESULT:
      return MatchResultVoting;
    default:
      throw `Undefined voting type - ${type}`;
  }
}



// WEBPACK FOOTER //
// ./src/api/voting/factory.ts